import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as e } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './page-header.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';

let PageHeader = class PageHeader extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.buttons = 1;
    }
    render() {
        return x `<div class="page-header-container" dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}" role="banner" aria-labelledby="${this.componentId}-title" aria-describedby="${this.componentId}-text"><div class="page-header"><slot name="main-image"></slot></div><div class="page-header__content-box page-header__content-box${this.rtl ? '--rtl' : '--ltr'}"><div class="page-header__text-container"><slot name="eyebrow-content"></slot><slot name="title-content" id="title"></slot><slot name="main-text" id="description"></slot></div><slot name="cta" id="cta"></slot></div></div>`;
    }
};
PageHeader.styles = css_248z;
__decorate([
    n({ type: Boolean })
], PageHeader.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], PageHeader.prototype, "eyebrow", void 0);
__decorate([
    n({ type: Number })
], PageHeader.prototype, "buttons", void 0);
__decorate([
    n({ type: String })
], PageHeader.prototype, "componentId", void 0);
PageHeader = __decorate([
    e('page-header')
], PageHeader);

export { PageHeader };
